import React from 'react';
import classNames from 'classnames/bind';

import { IconType } from 'types/icon';

import styles from './IconDeprecated.module.scss';

const c = classNames.bind(styles);

export type IconProps = React.HTMLAttributes<SVGSVGElement> & {
  name: IconType;
  className?: string;
  size?: 'small' | 'xsmall' | 'medium' | 'large';
  unstyled?: boolean;
};

/** @deprecated */
function Icon(
  { name, className, size = 'medium', unstyled, ...rest }: IconProps,
  ref: React.ForwardedRef<SVGSVGElement>
) {
  const props = {
    className: c('icon', { unstyled }, className, size),
    ...rest,
  };

  return (
    <svg {...props} ref={ref}>
      <use xlinkHref={`/__spritemap#sprite-${name}`} />
    </svg>
  );
}

const forwardedRef = React.forwardRef(Icon);

export { forwardedRef as Icon };
